import { render, staticRenderFns } from "./VideoPlayerAdvancedControls.vue?vue&type=template&id=affba250&scoped=true&"
import script from "./VideoPlayerAdvancedControls.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerAdvancedControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affba250",
  null
  
)

export default component.exports